import React, { Component } from 'react';
import Lightbox from 'lightbox-react';
import photos from '../data/photos.json';

import "../css/photogallery.css";

class PhotoGallery extends Component {
    constructor() {
        super();

        this.state = {
            index: 0,
            isOpen: false
        };

        this.openLightbox = this.openLightbox.bind(this);
        this.closeLightbox = this.closeLightbox.bind(this);
        this.moveNext = this.moveNext.bind(this);
        this.movePrev = this.movePrev.bind(this);
        this.onImageLoadError = this.onImageLoadError.bind(this);
    }

    openLightbox(event) {
        console.log(event.target.id);
        const openid = event.target.id.replace("photo_thumb_", "");
        console.log(openid);
        this.setState({ isOpen: true, index: openid });
    }

    closeLightbox() {
        this.setState({ isOpen: false });
    }

    moveNext() {
        this.setState({ index: (this.state.index + 1) % photos.length });
    }

    movePrev() {
        this.setState({ index: (this.state.index + photos.length - 1) % photos.length });
    }

    onImageLoadError(imageSrc, _srcType, errorEvent) {
        console.error('Could not load image at' + imageSrc, errorEvent); // eslint-disable-line no-console
    }

    render() {
        let lightbox = '';
        if (this.state.isOpen) {
            lightbox =
                <Lightbox
                    mainSrc={photos[this.state.index].src}
                    nextSrc={photos[(this.state.index + 1) % photos.length].src}
                    prevSrc={photos[(this.state.index + photos.length - 1) % photos.length].src}

                    mainSrcThumbnail={photos[this.state.index].thumb}
                    nextSrcThumbnail={photos[(this.state.index + 1) % photos.length].thumb}
                    prevSrcThumbnail={photos[(this.state.index + photos.length - 1) % photos.length].thumb}

                    onCloseRequest={this.closeLightbox}
                    onMovePrevRequest={this.movePrev}
                    onMoveNextRequest={this.moveNext}
                    onImageLoadError={this.onImageLoadError}

                    imageTitle={photos[this.state.index].title}
                    imageCaption={'Foto ' + this.state.index + ' di ' + photos.length}
                    discourageDownloads={true}
                />;
        }
        return (
            <div>
                <div className="row mdb-lightbox">
                    {
                        photos.map((photo, index) =>
                            <div className="col-md-4 text-center" style={{cursor: 'zoom-in'}} key={index}>
                                    <img data-wow-delay={"0." + index + "s"} src={photo.thumb} id={"photo_thumb_" + index} alt={photo.title} title={photo.title} className="img-fluid img-thumbnail photo-thumb wow bounceIn" onClick={this.openLightbox} />
                            </div>
                        )}
                </div>
                {lightbox}
            </div>
        );
    }
}

export default PhotoGallery;


// WEBPACK FOOTER //
// ./src/components/PhotoGallery.js